import React from 'react'
import { Container, Divider, List, Flag } from 'semantic-ui-react'

const InfoList = () => (
  <Container>
    <List>
      <List.Item>
        <List.Icon name="user" />
        <List.Content>Gustavo Santos</List.Content>
      </List.Item>
      <List.Item>
        <List.Icon name="student" />
        <List.Content>Engenharia de Computação @ UFPEL</List.Content>
      </List.Item>
      <List.Item>
        <List.Icon name="marker" />
        <List.Content>Pelotas, RS <Flag name="br" /></List.Content>
      </List.Item>
      <List.Item>
        <List.Icon name="mail" />
        <List.Content>
          <a href="mailto:gfdsantos@inf.ufpel.edu.br">gfdsantos@inf.ufpel.edu.br</a>
        </List.Content>
      </List.Item>
      <List.Item>
        <List.Icon name="bitcoin" />
        <List.Content>1FMrzKGmhCWETNbNn6MpYNW4Vtap3anxoa</List.Content>
      </List.Item>
    </List>

    <Divider hidden />
  </Container>
)

export default InfoList


// WEBPACK FOOTER //
// ./src/components/InfoList.js